/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbItem as CarbonBreadcrumbItem } from 'carbon';

export default class BreadcrumbItem extends Component {
	static propTypes = {
		/** Provide if this breadcrumb item represents the current page */
		isCurrentPage: PropTypes.node,
	};

	render() {
		const { isCurrentPage, ...other } = this.props;

		return <CarbonBreadcrumbItem isCurrentPage={isCurrentPage} {...other} />;
	}
}
